import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import { Fab, Paper, Box } from "@material-ui/core";
import { darken } from "@material-ui/core/styles/colorManipulator";

import MobileChartsPanel from "./MobileChartsPanel";

import { color } from "d3-color";

import SelectionBar from "./SelectionBar";

const MobileFab = withStyles((theme) => ({
  root: {
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    pointerEvents: "all",
  },
}))(Fab);

const MobileInfoContainer = withStyles((theme) => ({
  root: {
    position: "absolute",
    bottom: theme.spacing(0),
    right: theme.spacing(0),
    left: theme.spacing(0),
    padding: theme.spacing(2),
    height: "45%",
    pointerEvents: "all",
    display: "flex",
    flexDirection: "column",
    backgroundColor: color(theme.palette.primary.dark)
      .copy({ opacity: 0.5 })
      .formatRgb(),
  },
}))(Box);


// Component
const MobileCharts = ({ timeline, topRanking, bottomRanking }) => {
  const [show, setShow] = useState(true);

  function handleToggle() {
    setShow(() => setShow(!show));
  }

  return (
    <div>
      {show ? (
        <MobileInfoContainer>
          <MobileChartsPanel steps={[timeline, topRanking, bottomRanking]}></MobileChartsPanel>
        </MobileInfoContainer>
      ) : undefined}
      <MobileFab color="primary" aria-label="add" onClick={handleToggle}>
        {show ? <CloseIcon /> : <AddIcon />}
      </MobileFab>
    </div>
  );
};

const SelectionBarContainer = withStyles((theme) => ({
  root: {
    pointerEvents: "all",
  },
  outlined: {
    borderTop: 0,
    borderBottom: `1px solid ${darken(theme.palette.divider, 0.1)}`,
  },
}))(({ children, classes }) => {
  return (
    <Paper classes={classes} elevation={1}>
      {children}
    </Paper>
  );
});

const ContentContainer = withStyles((theme) => ({
  root: {
    position: "relative",
  },
}))(Box);

const MapTypeContainer = withStyles((theme) => ({
  root: {
    position: "absolute",
    top: theme.spacing(2),
    right: theme.spacing(1),
    pointerEvents: "all",
  },
}))(Box);

const ColorReferenceContainer = withStyles((theme) => ({
  root: {
    pointerEvents: "all",
    position: "absolute",
    top: theme.spacing(2),
    left: theme.spacing(1),
  },
}))(Box);

export default function MobileContent({
  mapTypeSelector,
  colorReference,
  country,
  selectedDate,
  onCountryChange,
  onSelectedDateChange,
  baselineDate,
  onBaselineDateChange,
  timeline,
  minDate,
  maxDate,
  topRanking,
  bottomRanking,
  period,
  onPeriodChange
}) {
  return (
    <Box pt={1} pr={0.5} pl={0.5}>
      <SelectionBarContainer>
        <SelectionBar
          minDate={minDate}
          maxDate={maxDate}
          onCountryChange={onCountryChange}
          country={country}
          selectedDate={selectedDate}
          onSelectedDateChange={onSelectedDateChange}
          baselineDate={baselineDate}
          onBaselineDateChange={onBaselineDateChange}
          period={period}
          onPeriodChange={onPeriodChange}
        />
      </SelectionBarContainer>
      <ContentContainer>
        <MapTypeContainer>{mapTypeSelector}</MapTypeContainer>
        <ColorReferenceContainer>{colorReference}</ColorReferenceContainer>
      </ContentContainer>
      <MobileCharts timeline={timeline} topRanking={topRanking} bottomRanking={bottomRanking}/>
    </Box>
  );
}
